module.exports = "<div class=\"bank-card-payment-network-icon text-center\">\r\n  <i class=\"{{ fontAwesomeIcon }} fa-3x\"></i>\r\n</div>"